import React, { useMemo, useState } from "react";
import { useLocation, NavLink } from "react-router-dom";
import { Collapse, Nav } from "react-bootstrap";

function Sidebar({ color, image, routes }) {
  const location = useLocation();

  const sections = useMemo(() => {
    const grouped = [];
    const indexByName = new Map();
    routes.forEach((route) => {
      if (route.redirect) return;
      const sectionName = route.section || "General";
      if (!indexByName.has(sectionName)) {
        indexByName.set(sectionName, grouped.length);
        grouped.push({ name: sectionName, items: [] });
      }
      grouped[indexByName.get(sectionName)].items.push(route);
    });
    return grouped;
  }, [routes]);

  const isPathActive = (path) =>
    location.pathname === path || location.pathname.startsWith(path + '/');

  const activeSection = useMemo(() => {
    const match = sections.find((section) =>
      section.items.some((item) => isPathActive(item.path))
    );
    return match ? match.name : sections[0]?.name;
  }, [sections, location.pathname]);

  const [openSections, setOpenSections] = useState(() => ({
    [activeSection]: true,
  }));

  React.useEffect(() => {
    if (!activeSection) return;
    setOpenSections((prev) =>
      prev[activeSection] ? prev : { ...prev, [activeSection]: true }
    );
  }, [activeSection]);

  const toggleSection = (name) => {
    setOpenSections((prev) => ({ ...prev, [name]: !prev[name] }));
  };


  return (
    <div className="sidebar" data-image={image} data-color={color}>
      <div
        className="sidebar-background"
        style={{ backgroundImage: "url(" + image + ")" }}
      />
      <div className="sidebar-wrapper">
        <div className="logo">
          <div className="logo-badge">C2C</div>
          <span className="simple-text">Monitor</span>
        </div>

        <Nav as="ul" className="sidebar-nav">
          {sections.map((section) => {
            const open = !!openSections[section.name];
            return (
              <li key={section.name} className="sidebar-section">
                <button
                  type="button"
                  className={`sidebar-section-header ${open ? "open" : ""}`}
                  onClick={() => toggleSection(section.name)}
                  aria-expanded={open}
                >
                  <span className="sidebar-section-title">{section.name}</span>
                  <i className="sidebar-section-caret bi-chevron-down" />
                </button>
                <Collapse in={open}>
                  <div>
                    <ul className="sidebar-section-items">
                      {section.items.map((item, index) => (
                        <li
                          key={item.path || index}
                          className={isPathActive(item.path) ? "active" : ""}
                        >
                          <NavLink
                            exact
                            to={item.path}
                            className="nav-link"
                            activeClassName="active"
                          >
                            <i className={item.icon} />
                            <p>{item.name}</p>
                          </NavLink>
                        </li>
                      ))}
                    </ul>
                  </div>
                </Collapse>
              </li>
            );
          })}
        </Nav>
      </div>
    </div>
  );
}

export default Sidebar;
